import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { AddOrUpdateUserGroup, FetchWorkCalendarState, RemoveUserGroup } from "./work-calendar.actions";
import { WorkCalendarUser } from "@app/_models/work-calendar/work-calendar";


export interface WorkCalendarUserGroupModel {
    userGroupId: number;
    users: WorkCalendarUser[];
}

export interface WorkCalendarStateModel {
    userGroups: WorkCalendarUserGroupModel[];
}

const defaults: WorkCalendarStateModel = {
    userGroups: []
};


@State<WorkCalendarStateModel>({
    name: 'workCalendar',
    defaults: defaults,
  })
@Injectable()
export class WorkCalendarState {
    constructor() {}

    @Selector() static getWorkCalendarState(state: WorkCalendarStateModel): WorkCalendarStateModel {
        return state;
    }

    @Action(AddOrUpdateUserGroup) addOrUpdateUserGroup(ctx: StateContext<WorkCalendarStateModel>, action: AddOrUpdateUserGroup) {
        const state = ctx.getState();
        const existingGroupIndex = state.userGroups.findIndex(
        (group) => group.userGroupId === action.payload.userGroupId
        );

        let updatedUserGroups: WorkCalendarUserGroupModel[];

        if (existingGroupIndex > -1) {
        // Update existing user group
        updatedUserGroups = [...state.userGroups];
        updatedUserGroups[existingGroupIndex] = action.payload;
        } else {
        // Add new user group
        updatedUserGroups = [...state.userGroups, action.payload];
        }

        ctx.setState({
        ...state,
        userGroups: updatedUserGroups
        });
    }

    @Action(RemoveUserGroup) removeUserGroup(ctx: StateContext<WorkCalendarStateModel>, action: RemoveUserGroup) {
        const state = ctx.getState();
        const filteredUserGroups = state.userGroups.filter(
        (group) => group.userGroupId !== action.groupId
        );
        ctx.setState({
        ...state,
        userGroups: filteredUserGroups
        });
    }

    @Action(FetchWorkCalendarState) fetchWorkCalendarState(ctx: StateContext<WorkCalendarStateModel>) {
        return ctx.getState();
    }
}